import { AuditEntity } from "@app/common";
import { Address, Sepa } from "@app/core";
import { CustomerConnection, CustomerType } from "@app/customers-base";

export class Profile extends AuditEntity {
	id: number;
	type: CustomerType;
	clientId: number;
	email: string;
	companyEmail: string;
	password: string;
	confirmPassword: string;
	enabled: true;
	company: string;
	number: Number;
	salutation: string;
	title: string;
	firstName: string;
	lastName: string;
	birthdate: Date;
	phoneNumber: string;
	mobilePhoneNumber: string;
	companyPhoneNumber: string;
	fax: string;
	address: Address = new Address();
	sepa: Sepa = new Sepa();
	termsAccepted: boolean = true;
	billingAddress: Address;
	shippingAddress: Address;
	connections: CustomerConnection[] = [new CustomerConnection()];
}